import { useMutation } from "@apollo/client";
import { Box, PageGridContainer } from "@govlaunch/web";
import { useRouter } from "next/router";
import React from "react";
import { useSelfie } from "~/components/auth/Auth";
import CollectionsPageSeo from "~/components/seo/CollectionsPageSeo";
import useIsMobile from "~/lib/hooks/useIsMobile";
import ToggleBookmarkMutation from "~/lib/mutations/ToggleBookmarkMutation";
import {
  IToggleBookmarkMutation,
  IToggleBookmarkMutationVariables,
} from "~/lib/mutations/__generated__/ToggleBookmarkMutation.generated";
import HomepageNavigation from "~/src/components/home/HomepageNavigation";
import BundleCollections from "~/src/components/collection/BundleCollections";
import CollectionsListingPageFilters from "~/src/components/collection/CollectionsListingPageFilters";
import MyCollections, { ScrollToMyCollections } from "~/src/components/collection/MyCollections";
import SingleCollections from "~/src/components/collection/SingleCollections";

export default function CollectionsListingPage() {
  const router = useRouter();
  const isMobile = useIsMobile();
  const selfie = useSelfie();

  const [toggleBookmark] = useMutation<IToggleBookmarkMutation, IToggleBookmarkMutationVariables>(
    ToggleBookmarkMutation,
  );

  return (
    <div>
      <CollectionsPageSeo />
      <HomepageNavigation />

      <PageGridContainer>
        {isMobile && selfie && <ScrollToMyCollections />}

        <CollectionsListingPageFilters />

        <Box pt={isMobile ? 20 : 50}>
          <Box mb={6}>
            <BundleCollections
              query={router.query.query || ""}
              toggleBookmark={(_bookmarked, { variables }) => {
                toggleBookmark({
                  variables: variables,
                  refetchQueries: ["SelfieCollections"],
                });
              }}
              isMobile={isMobile}
            />
          </Box>
        </Box>
      </PageGridContainer>

      {selfie && (
        <Box mb={6}>
          <MyCollections
            query={router.query.query || ""}
            toggleBookmark={(_bookmarked, { variables }) => {
              toggleBookmark({
                variables: variables,
                refetchQueries: ["ListAllCollections", "SelfieCollections"],
              });
            }}
            isMobile={isMobile}
          />
        </Box>
      )}

      <SingleCollections
        query={router.query.query || ""}
        toggleBookmark={(_bookmarked, { variables }) => {
          toggleBookmark({
            variables: variables,
            refetchQueries: ["SelfieCollections"],
          });
        }}
        isMobile={isMobile}
      />
    </div>
  );
}
